import { render, staticRenderFns } from "./RegisterDownload.vue?vue&type=template&id=21353092&scoped=true&"
import script from "./RegisterDownload.vue?vue&type=script&lang=js&"
export * from "./RegisterDownload.vue?vue&type=script&lang=js&"
import style0 from "./RegisterDownload.vue?vue&type=style&index=0&id=21353092&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21353092",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib'
import { VDialog } from 'vuetify/lib'
installComponents(component, {
  VCard,
  VDialog,
})
